import { Injectable } from '@angular/core';
import { SpLevel, SpLevelsor } from '../entity/printportal';
import { CoreDateTimeService, formatDate } from '@scrollmax/core-nextgen/datetime';
import { SanitizerService } from './sanitizer.service';

@Injectable({
  providedIn: 'root'
})
export class ScrollLevelService {

    private level: SpLevel;
    private levelSor: SpLevelsor[] = [];

    constructor(private dateService: CoreDateTimeService) {}

    /**
     * Minden esetben inicializálnunk kell ezt a service-t
     * 
     * @param level 
     * @param levelSor 
     */
    init(level: SpLevel, levelSor: SpLevelsor[]): void {
        this.level = level;
        this.levelSor = levelSor;
    } 

    validate(): void {
        if (!this.level || !this.levelSor)
            throw Error('If you want to use this service, you will need to call init() method');
    }

    /**
     * Megszólítást adjuk vissza
     * @returns 
     */
    getMegszolitas(): string {
        
        this.validate();

        return this.level?.getSzovegek()['megszolitas'];
    }

    /**
     * Az ajánlat fő szövegrészeit szedjük össze
     * @returns 
     */  
    getAjanlatSzoveg(): string[] {

        const texts = [];
        if (this.level) {
            texts.push(SanitizerService.clearText(this.level?.getSzovegek()['elo']));
        }

        return texts;
    }

    /**
     * Ez a nagy rizsa lesz az ajánlat végén, köszönjük, hogy nálunk rendelt meg ilyenek... 
     * @returns 
     */
    getAjanlatUtoSzoveg(): string {

        const texts = [];
        (this.level?.getSzovegek()['uto'] as Array<string>)?.forEach((text) => {
        texts.push(text);
        });

        let utotext = texts.join(' ');
        // összes helyes &nbsp; tag cseréje
        utotext = utotext.replace(/\&nbsp;/g, " ")
        // összes helytelen nbsp tag cseréje
        utotext = utotext.replace(/\&nbsp/g, " ")

        // ha nem UL taggal kezdődik a szöveg, akkor valami régi formátumról van szó és erőszakkal 
        // próbálunk meg rendet tenni a tagek között
        if (!utotext.startsWith('<ul>')) {

        utotext = utotext.replace(/\. \n/g, "|");
        utotext = utotext.replace(/\.\n/g, "|");
        utotext = utotext.replace(/\!\n/g, "|");
        utotext = utotext.replace(/\n/g, " ");
    
        const un = [];
        const ut = utotext.split("|");
        ut.forEach(v => {
            un.push(v.trim());
        })
    
        const t = [];
        un.forEach(v => {
            t.push("<li>" + v + "</li>");
        });
    
        return t.length > 0 ? ('<ul>' + t.join(" ") + '</ul>') : utotext;

        } else {

        // UL-el kezdődő szövegeknél az általunk megkövetelt új formázási rendszert használja a rendszer. 
        // itt csak annyit kell tennünk, hogy hozzáadjuk a formázást az ul taghoz, hogy felismerje a rendszer
        utotext = utotext.replace(/<ul>/g, '<ul>');      

        return utotext;
        }

    }

    /**
     * Az ajánlat fejlécét adjuk vissza, mindenféle formázással
     * @returns 
     */
    getAjanlatCim(): string { 

        this.validate();

        if (this.getSorCimkeByType('iktszam')) { 
        return String.prototype.concat(this.getSorCimkeByType('iktszam'), ', ', this.level?.kuldonev, ' - ', this.getFormattedDate(this.level?.kelt));
        } else {
        return String.prototype.concat(this.level?.kuldonev, ' - ', this.getFormattedDate(this.level?.kelt));
        }
    }

    /**
     * Verzió szöveget formázzuk, illetve szedjük ki belőle a scroll formázásokat
     * 
     * @param value 
     * @returns 
     */
    formatVerzioSzoveg(value: string, classes: string = 'text-xs'): string {

        if (value) {
            const d = value.split('<BR>');
            const nd = [];
        
            d.forEach((value: string, index: number) => {
              if (value !== "<P>\r" && value !== "" && value !== "\r</P>") {
                nd.push("<li class=\"mt-2 mb-2\">" + value + "</li>");
              }
            });
        
            return '<ul class=' + classes + '>' + nd.join(" ") + '</ul>';
        }

        // ha az előbb nem tértünk vissza, akkor csak simán visszaküldjük a bemenetet...
        // TODO elég gyász megoldás, de ellenőriznünk kell, hogy nem -e futunk hibára a value -n
        return '<ul class=' + classes + '>' + value + '</ul>';
    }

    /**
     * Core metódus használatával alakítunk egy dátumot. Nem az igazi!
     * TODO CoreDateTimeService jó lenne ha ezt tudná metódusból és nem csak pipe-ből
     * 
     * @param datetime 
     * @returns 
     */
    private getFormattedDate(datetime: string): string {
        return formatDate('Y-m-d', new Date(datetime), 'en_US');
    }

    /**
     * Ez a funkciónk visszaad egy cimke értéket a kapott sor típus alapján
     */
    private getSorCimkeByType(tipus: string): string {

        // megpróbáljuk megkeresni ezt a sortípust, nem biztos, hogy van!
        const sor = this.level?.getTartalom().find(s => s['sortipus'] === tipus);  
        
        // ha van ilyen tipusú sor, akkor vizsgálunk az értéken is
        if (sor) {
            // eslint-disable-next-line no-prototype-builtins
            if (sor.hasOwnProperty('cimke'))
                return sor['cimke'];
        }

        return '';
    }
}